@if (markerPositions.length) {
	<div class="maps-localization">
		@if (showSearch) {
			<div class="maps-localization__search">
				<tec-input-search
					class="maps-localization__search-input"
					[placeholder]="'GENERAL.SEARCH' | translate"
					[size]="'md'"
					(keyup)="onSearchInput($event)"
					(close)="onSearchInput('')"
					(searchInput)="onSearchInput($event)"
				/>
				@if (showSearchMenu && searchOptions.length) {
					<tec-select
						[isOpen]="showSearchMenu"
						[formControl]="selectedOption"
						[multiple]="false"
						[options]="searchOptions"
						(valueChange)="onSearchSelect($event)"
					/>
				}
			</div>
		}
		<tec-map
			[markers]="filteredMarkers"
			[enableInfoWindow]="true"
			[enableSearch]="false"
		/>
	</div>
} @else {
	<tec-empty-state [title]="'GENERAL.NO_DATA' | translate" />
}
